import React from "react";
import { Box, Grid, makeStyles, Paper } from "@material-ui/core";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  textBox: {
    height: 50,
    margin: "5px 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxLines: 1,
  },
  bookTitle: {
    fontWeight: 500,
    margin: "0",
    maxLines: 1,
    lineClamp: 1,
    overflow: "hidden",
  },

  paper: {
    padding: 5,
    textAlign: "center",
  },
}));

const BookList = ({ books }) => {
  const classes = useStyles();

  return (
    <div>
      <Grid container spacing={2}>
        {books.map((book, index) => (
          <Grid item xs={12} md={4} lg={3} key={index}>
            {book.isPublished && book.isActive ? (
              <Link
                style={{ textDecoration: "none" }}
                to={`/author/book/${book._id}`}
              >
                <Paper elevation={2} className={classes.paper}>
                  <Box style={{ width: "90%", margin: "0 auto" }}>
                    <img
                      src={book.book_cover}
                      style={{
                        width: "100%",
                        height: 200,
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                  <Box className={classes.textBox}>
                    <h3 className={classes.bookTitle}>{book.book_title} </h3>
                  </Box>
                </Paper>
              </Link>
            ) : (
              <Paper elevation={2} className={classes.paper}>
                <Box style={{ width: "90%", margin: "0 auto" }}>
                  <img
                    src={book.book_cover}
                    style={{
                      width: "100%",
                      height: 200,
                      objectFit: "contain",
                    }}
                  />
                </Box>
                <Box className={classes.textBox}>
                  <h3 className={classes.bookTitle}>{book.book_title} </h3>
                </Box>
              </Paper>
            )}
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default BookList;
